import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ffffff;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  background: #ffffff;
  position: sticky;
  top: 0;
  z-index: 10;
  gap: 12px;
`

export const BackButton = styled.button`
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  color: #6b6b6b;

  &:hover {
    background: #f5f5f5;
    color: #1a1a1a;
  }
`

export const HeaderIcon = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #00ade6;
`

export const HeaderTitle = styled.h2`
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  flex: 1;
`

export const CloseButton = styled.button`
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  color: #999999;

  &:hover {
    background: #f5f5f5;
    color: #1a1a1a;
  }
`

export const FormContainer = styled.div`
  padding: 20px;
  flex: 1;
  overflow-y: auto;
`

export const FormGroup = styled.div`
  margin-bottom: 24px;
`

export const FormLabel = styled.label`
  font-size: 13px;
  font-weight: 500;
  color: #6b6b6b;
  margin-bottom: 8px;
  display: block;
`

export const SearchResults = styled.div`
  margin-top: 12px;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  background: #ffffff;
  max-height: 400px;
  overflow-y: auto;
`

export const SearchResultItem = styled.div<{ $selected: boolean }>`
  padding: 12px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 12px;
  background: ${({ $selected }) => ($selected ? '#e6f7fc' : '#ffffff')};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: ${({ $selected }) => ($selected ? '#e6f7fc' : '#f5f5f5')};
  }
`

export const SearchResultCheckbox = styled.div<{ $selected: boolean }>`
  width: 16px;
  height: 16px;
  border: 2px solid #e5e5e5;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;
  background: ${({ $selected }) => ($selected ? '#00ade6' : 'transparent')};
  border-color: ${({ $selected }) => ($selected ? '#00ade6' : '#e5e5e5')};

  &::after {
    content: ${({ $selected }) => ($selected ? "'✓'" : "''")};
    color: white;
    font-size: 10px;
    font-weight: bold;
  }
`

export const SearchResultInfo = styled.div`
  flex: 1;
  min-width: 0;
`

export const SearchResultName = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #1a1a1a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const SearchResultMeta = styled.div`
  font-size: 11px;
  color: #6b6b6b;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 2px;

  span {
    white-space: nowrap;
  }
`

export const SearchResultValue = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
  white-space: nowrap;
`

export const SelectedSummary = styled.div`
  padding: 8px 12px;
  background: #fafafa;
  border-radius: 6px;
  font-size: 12px;
  color: #6b6b6b;
  margin-top: 12px;
`

export const SelectedCount = styled.span`
  font-weight: 600;
  color: #00ade6;
`

export const FormFooter = styled.div`
  padding: 16px 20px;
  background: #fafafa;
  border-top: 1px solid #e5e5e5;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  position: sticky;
  bottom: 0;
`

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px;
  gap: 16px;
  flex: 1;

  div {
    font-size: 14px;
    color: #6b6b6b;
  }
`

export const EmptyState = styled.div`
  text-align: center;
  padding: 48px 24px;
`

export const EmptyIcon = styled.div`
  width: 48px;
  height: 48px;
  margin: 0 auto 16px;
  opacity: 0.2;
  color: #999999;
`

export const EmptyTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #1a1a1a;
`

export const EmptyDescription = styled.p`
  font-size: 13px;
  color: #6b6b6b;
  line-height: 1.5;
`
